module.exports = {
  __depends__: [ require(80) ],
  __init__: [ 'rules' ],
  rules: [ 'type', require(154) ]
};
